export const LANDING = {
  startQuizBtn: "start-quiz-btn",
  navAdminBtn: "nav-admin-btn",
  navLogo: "nav-logo",
  heroPrimaryCta: "hero-primary-cta",
};

export const QUIZ = {
  container: "quiz-container",
  progress: "quiz-progress",
  questionTitle: "quiz-question-title",
  optionBtn: (qid, value) => `quiz-option-${qid}-${value}`,
  backBtn: "quiz-back-btn",
  nextBtn: "quiz-next-btn",
};

export const LEAD = {
  form: "lead-form",
  nameInput: "lead-name-input",
  emailInput: "lead-email-input",
  companyInput: "lead-company-input",
  submitBtn: "lead-submit-btn",
};

export const RESULTS = {
  container: "results-container",
  blurb: "results-blurb",
  toolCard: (id) => `tool-card-${id}`,
  toolCta: (id) => `tool-cta-${id}`,
  restartBtn: "results-restart-btn",
};

export const ADMIN = {
  loginForm: "admin-login-form",
  loginEmail: "admin-login-email",
  loginPwField: "admin-login-pw-field",
  loginSubmit: "admin-login-submit",
  dashboard: "admin-dashboard",
  leadsTable: "admin-leads-table",
  exportCsvBtn: "admin-export-csv-btn",
  logoutBtn: "admin-logout-btn",
  statTotal: "admin-stat-total",
};
